import './breadcrumb_navigation.less';

import React from 'react';

import Breadcrumbs from 'zoomforth_component_lib/breadcrumbs.jsx';

export default ({ breadcrumbs }) => (
  <Breadcrumbs
    breadcrumbs={breadcrumbs}
    className="sidebar-breadcrumb-navigation"
  />
);
